<template>
  <div class="main" id="large-screen-index" @click="TurnOnSound = true">
    <!-- ==================== 顶部栏 ==================== -->
    <div class="head">
      <div class="head-left">
        <span class="head-date">{{ time.split(' ')[0] }}</span>
        <span class="head-week">{{ week }}</span>
        <span class="head-time">{{ time.split(' ')[1] }}</span>
      </div>
      <span class="head-title">智慧养老服务平台</span>
      <i @click="back" class="el-icon-switch-button head-exit"></i>
    </div>

    <!-- ==================== 主体三栏 ==================== -->
    <div class="body">
      <!-- ========== 左列 ========== -->
      <div class="body-left">
        <!-- 人员情况统计 -->
        <div class="panel">
          <div class="panel-header">
            <span class="panel-header-bar"></span>
            <span class="panel-header-title">人员情况统计</span>
          </div>
          <el-carousel :interval="5000" arrow="never" class="echart-carousel">
            <el-carousel-item v-for="i in 3" :key="i">
              <div :id="'EchartId-' + i" class="pie-chart"></div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <!-- 今日值班人员 -->
        <div class="panel panel-flex">
          <div class="panel-header">
            <span class="panel-header-bar"></span>
            <span class="panel-header-title">今日值班人员信息</span>
          </div>
          <div class="simple-table">
            <div class="simple-table-head">
              <span class="flex-1 text-center">值班日期</span>
              <span class="flex-1 text-center">值班员</span>
              <span class="flex-1 text-center">角色</span>
            </div>
            <div class="simple-table-body">
              <div class="simple-table-row" v-for="(item, index) in duty" :key="index">
                <span class="flex-1 text-center">{{ item.shift_time }}</span>
                <span class="flex-1 text-center">{{ item.user ? item.user.name : '-' }}</span>
                <span class="flex-1 text-center">{{ item.user && item.user.roles && item.user.roles[0] ? item.user.roles[0].title : '-' }}</span>
              </div>
              <div v-if="!duty.length" class="empty-row">暂无值班安排</div>
            </div>
          </div>
        </div>

        <!-- 风险处理 -->
        <div class="panel panel-flex-last">
          <div class="panel-header">
            <span class="panel-header-bar"></span>
            <span class="panel-header-title">风险处理</span>
          </div>
          <div class="data-table">
            <div class="data-table-head">
              <span class="col-3">申请人</span>
              <span class="col-4">房间</span>
              <span class="col-4-half text-center">类型</span>
              <span class="col-5">预警时间 - 处理时间</span>
              <span class="col-6 text-center">{{ operationAuth ? '处理人' : '状态' }}</span>
            </div>
            <div class="data-table-body">
              <div class="data-table-row" v-for="(item, index) in sosHis" :key="index">
                <span class="col-3">{{ item.member ? item.member.realname : '-' }}</span>
                <span class="col-4" :title="item.address">{{ item.address || '-' }}</span>
                <span class="col-4-half text-center">{{ item.type ? SOStypeDict[item.type].name : '-' }}</span>
                <span class="col-5">
                  <span>{{ item.created_at }}</span>
                  <span class="time-sep">|</span>
                  <span>{{ item.updated_at }}</span>
                </span>
                <span class="col-6 text-center">
                  <template v-if="!operationAuth">
                    {{ item.status != null ? sosHisStatusDict[item.status].name : '-' }}
                  </template>
                  <template v-else-if="item.status === 2">
                    {{ item.user ? item.user.name : '-' }}
                  </template>
                  <span v-else-if="operationAuth && item.status != 2" class="btn btn-primary" @click="toOtherPath('/safety/alarm')">处理</span>
                </span>
              </div>
              <div v-if="!sosHis.length" class="empty-row">暂无风险记录</div>
            </div>
          </div>
        </div>
      </div>

      <!-- ========== 中列 ========== -->
      <div class="body-mid">
        <!-- 风险预警 + SOS弹窗 -->
        <div class="panel panel-alert">
          <div class="alert-content">
            <div class="alert-left">
              <div class="alert-left-head">
                <span class="panel-header-bar" style="margin-left: 0.5vw;"></span>
                <span class="panel-header-title">风险预警</span>
                <div class="alert-sound-toggle">
                  <span class="sound-label">开启报警音：</span>
                  <el-switch v-model="TurnOnSound" active-color="#13ce66" inactive-color="#ff4949" size="mini" :disabled="TurnOnSound" />
                </div>
              </div>
              <div class="alert-table-head">
                <span class="col-12">报警人</span>
                <span class="col-13">房间</span>
                <span class="col-13-half">类型</span>
                <span class="col-14 text-center">操作</span>
              </div>
              <div class="alert-table-body">
                <div class="alert-table-row" v-for="(item, index) in sos" :key="index">
                  <span class="col-12">{{ item.member ? item.member.realname : '-' }}</span>
                  <span class="col-13" :title="item.address">{{ item.address || '-' }}</span>
                  <span class="col-13-half">{{ SOStypeDict[item.type] ? SOStypeDict[item.type].name : '-' }}</span>
                  <span class="col-14 text-center">
                    <span class="btn btn-success" v-if="operationAuth && item.member" @click="callVideo(item.member_id, item.id, 'sos')">连线</span>
                    <span class="btn btn-primary" v-if="operationAuth && !item.member" @click="handleRiskWarning(item.id)">处理</span>
                    <span v-if="!operationAuth">-</span>
                  </span>
                </div>
                <div v-if="!sos.length" class="empty-row">暂无预警信息</div>
              </div>
            </div>

            <!-- SOS弹窗区域 -->
            <div class="alert-right">
              <!-- 房间SOS -->
              <div class="popup-sos" v-if="sosShow">
                <div class="popup-card" :class="startFlag ? 'border-alert' : 'border-normal'">
                  <div class="popup-card-head">
                    <div class="row">
                      <img class="popup-icon" src="../../assets/large-screen/smallBell.png" alt="警告">
                      <span class="popup-title">SOS紧急求助</span>
                    </div>
                    <img class="popup-icon popup-close" src="../../assets/large-screen/fork.png" alt="关闭" @click="closePopup">
                  </div>
                  <div class="popup-user">
                    <img class="popup-avatar" :src="sosInfo.photo" alt="头像">
                    <span class="popup-name">{{ sosInfo.realname }}</span>
                  </div>
                  <div class="popup-info">
                    <span>性别：{{ sosInfo.sex }}</span>
                    <span>手机：{{ sosInfo.mobile }}</span>
                  </div>
                  <div class="popup-info"><span>生日：{{ sosInfo.birthday }}</span></div>
                  <div class="popup-info"><span>用药历史：{{ sosInfo.medication }}</span></div>
                  <div class="popup-info"><span>疾病史：{{ sosInfo.disease }}</span></div>
                  <div class="popup-info"><span>住址：{{ sosInfo.address }}</span></div>
                  <div class="popup-action">
                    <span class="btn btn-success btn-block" @click="callVideo(sosInfo.userId, sosInfo.alarmId)">连线</span>
                  </div>
                </div>
              </div>

              <!-- 其他SOS -->
              <div class="popup-placeholder" v-else-if="sosOtherShow">
                <div class="popup-sos-other">
                  <div class="popup-other-card" :class="startFlag ? 'border-alert' : 'border-normal'">
                    <div class="popup-card-head">
                      <div class="row">
                        <img class="popup-icon" src="../../assets/large-screen/smallBell.png" alt="警告">
                        <span class="popup-title">SOS紧急求助</span>
                      </div>
                      <img class="popup-icon popup-close" src="../../assets/large-screen/fork.png" alt="关闭" @click="closePopup">
                    </div>
                    <div class="popup-card-head">
                      <div class="row">
                        <img class="popup-icon-location" src="../../assets/large-screen/location.png" alt="定位">
                        <span class="popup-location-text">{{ sosOtherInfo.title }}</span>
                      </div>
                    </div>
                    <img class="popup-map" :src="sosOtherInfo.photo" alt="地图">
                  </div>
                </div>
              </div>

              <!-- 占位 -->
              <div class="popup-placeholder" v-else></div>

              <!-- 燃气警报 -->
              <div class="popup-gas" v-if="gasShow">
                <div class="popup-card popup-gas-card" :class="startFlag ? 'border-alert' : 'border-normal'">
                  <div class="popup-card-head">
                    <div class="row">
                      <img class="popup-icon" src="../../assets/large-screen/smallBell.png" alt="警告">
                      <span class="popup-title">燃气警报</span>
                    </div>
                    <img class="popup-icon popup-close" src="../../assets/large-screen/fork.png" alt="关闭" @click="closePopup">
                  </div>
                  <div class="popup-user">
                    <img class="popup-avatar" :src="gasInfo.photo" alt="头像">
                    <span class="popup-name">{{ gasInfo.realname }}</span>
                  </div>
                  <div class="popup-info"><span>房间号：{{ gasInfo.address }}</span></div>
                </div>
              </div>
              <div class="popup-placeholder" v-else></div>
            </div>
          </div>
        </div>

        <!-- 生命体征监测 -->
        <div class="panel panel-vital">
          <div class="panel-header">
            <span class="panel-header-bar"></span>
            <span class="panel-header-title">生命体征监测</span>
          </div>
          <div class="vital-table">
            <div class="vital-table-head">
              <span class="v-col v-col-1">序号</span>
              <span class="v-col v-col-1">姓名</span>
              <span class="v-col v-col-2">房间号</span>
              <span class="v-col v-col-1">心率</span>
              <span class="v-col v-col-1">呼吸</span>
              <span class="v-col v-col-3">收缩压/舒张压</span>
              <span class="v-col v-col-1">脉率</span>
              <span class="v-col v-col-1">血糖</span>
              <span class="v-col v-col-1">血氧</span>
              <span class="v-col v-col-4">床垫状态</span>
            </div>
            <div class="vital-table-body" id="scrollDOM" @mouseover="handleMouseover" @mouseleave="handleMouseleave">
              <div class="vital-table-row" v-for="(item, index) in monitorData" :key="index">
                <span class="v-col v-col-1">{{ index + 1 }}</span>
                <span class="v-col v-col-1">{{ item.realname }}</span>
                <span class="v-col v-col-2" :title="item.address">{{ item.address || '-' }}</span>
                <span class="v-col v-col-1">{{ item.sm && item.sm.info ? item.sm.info.heart : '——' }}</span>
                <span class="v-col v-col-1">{{ item.sm && item.sm.info ? item.sm.info.breath : '——' }}</span>
                <span class="v-col v-col-3">{{ item.health_patrol ? item.health_patrol.sp : '——' }}/{{ item.health_patrol ? item.health_patrol.dp : '——' }}</span>
                <span class="v-col v-col-1">{{ item.health_patrol ? item.health_patrol.pr : '——' }}</span>
                <span class="v-col v-col-1">{{ item.health_patrol ? item.health_patrol.blood : '——' }}</span>
                <span class="v-col v-col-1">{{ item.health_patrol ? item.health_patrol.spo2h : '——' }}</span>
                <span class="v-col v-col-4">
                  <template v-if="item.sm">
                    <span class="vital-dot" :class="'vital-dot-' + item.sm.online_status"></span>
                    <span class="vital-status-text" :class="'vital-status-' + item.sm.online_status">
                      {{ item.sm.online_status === 0 ? '床垫离线' : item.sm.online_status === 1 ? '设备在线' : item.sm.online_status === 2 ? '在床' : '离床' }}
                    </span>
                  </template>
                  <span v-else class="vital-status-text">——</span>
                </span>
              </div>
              <div v-if="!monitorData.length" class="empty-row">暂无监测数据</div>
            </div>
          </div>
        </div>
      </div>

      <!-- ========== 右列 ========== -->
      <div class="body-right">
        <!-- 公告 -->
        <div class="panel">
          <div class="panel-header">
            <span class="panel-header-bar"></span>
            <span class="panel-header-title">公告</span>
          </div>
          <div class="notice-scroll" id="noticeScroll" @mouseover="handleNoticeMouseover" @mouseleave="handleNoticeMouseleave">
            <div class="notice-card" v-for="(item, index) in announcement" :key="index"
              :style="{ borderBottom: index !== announcement.length - 1 ? '1px solid rgba(1, 194, 255, 0.3)' : 'none' }">
              <div class="notice-card-head">
                <span class="notice-card-title">{{ item.title }}</span>
                <span class="notice-card-time">{{ item.created_at }}</span>
              </div>
              <div class="notice-card-body">{{ item.content }}</div>
            </div>
            <div v-if="!announcement.length" class="empty-row">暂无公告</div>
          </div>
        </div>

        <!-- 今日派车记录 -->
        <div class="panel panel-flex">
          <div class="panel-header">
            <span class="panel-header-bar"></span>
            <span class="panel-header-title">今日派车记录</span>
          </div>
          <div class="data-table">
            <div class="data-table-head">
              <span class="col-3">申请人</span>
              <span class="col-4">目的地</span>
              <span class="col-4-half">状态</span>
              <span class="col-5">出发时间 - 返回时间</span>
              <span class="col-6 text-center">操作</span>
            </div>
            <div class="data-table-body data-table-body-sm">
              <div class="data-table-row" v-for="(item, index) in carApplication" :key="index">
                <span class="col-3">
                  <template v-if="item.status == 1">
                    <span class="new-dot"></span>{{ item.applicant }}
                  </template>
                  <span v-else>{{ item.applicant }}</span>
                </span>
                <span class="col-4" :title="item.target">{{ item.target }}</span>
                <span class="col-4-half">{{ item.status != null && auditStatusDict[item.status] ? auditStatusDict[item.status].name : '-' }}</span>
                <span class="col-5">
                  <span>{{ item.dispatch_time }}</span>
                  <span class="time-sep">|</span>
                  <span>{{ item.return_time }}</span>
                </span>
                <span class="col-6 text-center" v-if="operationAuth">
                  <span class="btn btn-primary" @click="toOtherPath('/dispatch-vehicle/service')">处理</span>
                  <span class="btn btn-success" @click="callVideo(item.member_id)">连线</span>
                </span>
              </div>
              <div v-if="!carApplication.length" class="empty-row">暂无派车记录</div>
            </div>
          </div>
        </div>

        <!-- 叫餐 -->
        <div class="panel panel-flex-last">
          <div class="panel-header">
            <span class="panel-header-bar"></span>
            <span class="panel-header-title">叫餐</span>
          </div>
          <div class="meal-table">
            <div class="meal-table-head">
              <span class="meal-col text-center">申请人</span>
              <span class="meal-col">类型</span>
              <span class="meal-col-wide">名称</span>
              <span class="meal-col text-center">操作</span>
            </div>
            <div class="meal-table-body">
              <div class="meal-table-row" v-for="(item, index) in meal" :key="index">
                <span class="meal-col text-center">{{ item.member ? item.member.realname : '-' }}</span>
                <span class="meal-col">{{ item.type == 1 ? '早餐' : item.type == 2 ? '午餐' : item.type == 3 ? '晚餐' : '-' }}</span>
                <span class="meal-col-wide" :title="item.content">{{ item.content }}</span>
                <span class="meal-col text-center" v-if="operationAuth">
                  <span class="btn btn-primary" @click="toOtherPath('/order/index')">处理</span>
                  <span class="btn btn-success" style="margin-left: 4px;" @click="callVideo(item.member_id)">连线</span>
                </span>
                <span class="meal-col text-center" v-else>-</span>
              </div>
              <div v-if="!meal.length" class="empty-row">暂无叫餐记录</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <VideoCallDialog ref="videoCall" @closeCallDialog="closeCallDialog" />

    <audio ref="audio" v-if="needVideo" loop :muted="mutedFlag" class="audio-hidden">
      <source src="../../assets/large-screen/warn.mp3">
    </audio>
    <audio ref="audio2" v-if="needPromptVideo" :muted="mutedPromptFlag" class="audio-hidden">
      <source src="../../assets/large-screen/prompt.mp3">
    </audio>
  </div>
</template>

<script>
import { getMonitorAPI, alarmResponseAPI } from '@/api/large.js'
import { formatDate } from '@/utils/common-fun'
import * as echarts from 'echarts'
import VideoCallDialog from '@/components/VideoCallDialog.vue'

const WEEK_NAMES = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']

const BaseOption = {
  title: {
    text: '',
    left: 'center',
    textStyle: { color: '#ffffff', fontSize: 14, fontWeight: 500 }
  },
  tooltip: { trigger: 'item' },
  color: ['#07D1FA', '#0783FA', '#00D68F', '#FFAA00', '#FF6B6B', '#A78BFA'],
  legend: {
    data: [],
    textStyle: { color: 'rgba(255,255,255,0.75)', fontSize: 10 },
    bottom: 0,
    padding: [5, 0],
    itemGap: 8,
    type: 'scroll',
    itemHeight: 8,
    itemWidth: 12
  },
  series: [{
    type: 'pie',
    radius: ['45%', '70%'],
    data: [],
    emphasis: {
      itemStyle: {
        shadowBlur: 20,
        shadowOffsetX: 0,
        shadowColor: 'rgba(0, 0, 0, 0.5)'
      }
    },
    labelLine: { show: false },
    label: { show: false },
    animationType: 'scale',
    animationEasing: 'elasticOut'
  }]
}

export default {
  name: 'large-screen',
  components: { VideoCallDialog },

  data() {
    return {
      sosChannel: process.env.VUE_APP_SOS_CHANNEL,

      auditStatusDict: {
        1: { name: '待安排', type: 'warning', value: 1 },
        2: { name: '已安排', type: 'primary', value: 2 },
        3: { name: '审批通过', type: 'success', value: 3 },
        4: { name: '审批驳回', type: 'danger', value: 4 },
        5: { name: '已出营', type: 'primary', value: 5 },
        6: { name: '已返回', type: 'success', value: 6 }
      },

      SOStypeDict: {
        1: { name: 'SOS呼救' },
        2: { name: '燃气报警' },
        4: { name: '离床预警' },
        5: { name: '派车提示' },
        6: { name: '点餐提示' },
        7: { name: '心率异常' },
        8: { name: '呼吸异常' }
      },

      sosHisStatusDict: {
        0: { name: '待响应' },
        1: { name: '已响应' },
        2: { name: '已处理' }
      },

      // 数据
      duty: [],
      carApplication: [],
      announcement: [],
      gas: [],
      meal: [],
      member: {},
      sos: [],
      monitorData: [],
      sosHis: [],

      // 定时器
      dataTimer: null,
      timer: null,
      scrollTimer: null,
      noticeTimer: null,
      startTimer: null,

      // 时间
      time: '2020-10-10 12:00:00',
      week: '星期一',

      // ECharts
      myChart_1: null,
      myChart_2: null,
      myChart_3: null,

      // SOS弹窗
      sosInfo: {},
      sosShow: false,
      sosOtherShow: false,
      sosOtherInfo: { title: '', photo: '' },
      gasInfo: {},
      gasShow: false,
      startFlag: false,

      // 音频
      needVideo: false,
      mutedFlag: true,
      needPromptVideo: false,
      mutedPromptFlag: false,
      TurnOnSound: false,

      // 权限
      operationAuth: false,

      // 通话状态
      isCall: false
    }
  },

  created() {
    this.operationAuth = this.getOperationAuth()
    this.getTime()
    this.getAllData()
    clearInterval(this.dataTimer)
    this.dataTimer = setInterval(() => this.getAllData(), 60000)
  },

  mounted() {
    this.connect()
  },

  beforeDestroy() {
    clearInterval(this.dataTimer)
    clearInterval(this.timer)
    clearInterval(this.scrollTimer)
    clearInterval(this.noticeTimer)
    clearInterval(this.startTimer)
  },

  methods: {
    // ==================== 权限 ====================
    getOperationAuth() {
      const roles = JSON.parse(sessionStorage.getItem('roleList') || '[]')
      return !roles.some(item => item.name === 'Monitor')
    },

    // ==================== 导航 ====================
    back() {
      if (document.exitFullscreen) document.exitFullscreen()
      else if (document.msExitFullscreen) document.msExitFullscreen()
      else if (document.mozCancelFullScreen) document.mozCancelFullScreen()
      else document.webkitCancelFullScreen()
      clearInterval(this.scrollTimer)
      clearInterval(this.noticeTimer)
      this.$router.back()
    },

    toOtherPath(path) {
      if (!path) return
      const url = window.location.href.replace(/\/large-screen/, '')
      window.open(`${url}${path}`, '_blank')
    },

    // ==================== 时间 ====================
    getTime() {
      const now = new Date()
      this.time = formatDate(now)
      this.week = WEEK_NAMES[now.getDay()]
      clearInterval(this.timer)
      this.timer = setInterval(() => this.getTime(), 1000)
    },

    // ==================== 数据 ====================
    getAllData() {
      getMonitorAPI().then(res => {
        this.duty = res.duty || []
        this.carApplication = res.carApplication || []
        this.announcement = res.announcement || []

        this.sosHis = (res.sosHis || []).map(item => this.memberSetAddress(item))
        this.gas = (res.gas || []).map(item => this.memberSetAddress(item))
        this.sos = (res.sos || []).map(item => this.memberSetAddress(item))
        this.member = res.member || {}

        this.monitorData = (res.monitorData || []).map(item => {
          item.address = item.room
            ? [item.room.floor.building.area.name,
               item.room.floor.building.name,
               item.room.floor.name,
               item.room.name].filter(Boolean).join('')
            : ''
          return item
        })

        this.meal = (res.meal || []).map(item => {
          item.content = (item.item || []).map(t => t.meal.meal_name).join(',')
          return item
        })

        this.setEchart()
        this.startScroll()
        this.noticeScroll()
      })
    },

    memberSetAddress(item) {
      item.address = item.member && item.member.room
        ? [item.member.room.floor.building.area.name,
           item.member.room.floor.building.name,
           item.member.room.floor.name,
           item.member.room.name].filter(Boolean).join('')
        : (item.device ? item.device.location : '')
      return item
    },

    // ==================== 滚动 ====================
    startScroll() {
      this.$nextTick(() => {
        clearInterval(this.scrollTimer)
        this.scrollTimer = setInterval(() => {
          const dom = document.querySelector('#scrollDOM')
          if (!dom) return
          dom.scrollTop += 1
          if (dom.scrollTop + dom.clientHeight >= dom.scrollHeight - 2) {
            dom.scrollTop = 0
          }
        }, 100)
      })
    },

    noticeScroll() {
      this.$nextTick(() => {
        clearInterval(this.noticeTimer)
        this.noticeTimer = setInterval(() => {
          const dom = document.querySelector('#noticeScroll')
          if (!dom) return
          dom.scrollTop += 1
          if (Math.ceil(dom.scrollTop + dom.clientHeight) >= dom.scrollHeight - 2) {
            dom.scrollTop = 0
          }
        }, 100)
      })
    },

    handleMouseover() { clearInterval(this.scrollTimer) },
    handleMouseleave() { this.startScroll() },
    handleNoticeMouseover() { clearInterval(this.noticeTimer) },
    handleNoticeMouseleave() { this.noticeScroll() },

    // ==================== ECharts ====================
    setPieChartSeries(arr) {
      const names = ['床垫预警', '一键救护', '燃气预警', '订餐服务', '派车服务', '公告学习']
      const indices = [1, 2, 3, 4, 5, 6]
      return indices.map((idx, i) => ({ name: names[i], value: arr[idx] || 0 })).filter(d => d.value > 0)
    },

    setPieChartProfile(type, series) {
      const option = JSON.parse(JSON.stringify(BaseOption))
      const titles = { today: '当天数据', week: '本周数据', month: '本月数据' }
      option.title.text = titles[type] || ''
      option.series[0].data = series
      option.legend.data = series.map(item => item.name)

      const charts = { today: this.myChart_1, week: this.myChart_2, month: this.myChart_3 }
      if (charts[type]) charts[type].setOption(option)
    },

    setEchart() {
      this.$nextTick(() => {
        const ids = ['EchartId-1', 'EchartId-2', 'EchartId-3']
        const refs = ['myChart_1', 'myChart_2', 'myChart_3']

        refs.forEach((ref, i) => {
          if (!this[ref]) {
            const dom = document.getElementById(ids[i])
            if (dom) this[ref] = echarts.init(dom)
          }
        })

        if (this.member.six_day) this.setPieChartProfile('today', this.setPieChartSeries(this.member.six_day))
        if (this.member.six_week) this.setPieChartProfile('week', this.setPieChartSeries(this.member.six_week))
        if (this.member.six_month) this.setPieChartProfile('month', this.setPieChartSeries(this.member.six_month))
      })
    },

    // ==================== 视频通话 ====================
    callVideo(id, dataId) {
      this.isCall = true
      this.$refs.videoCall.open(id)
      if (dataId) {
        this.$mqtt.publish(this.sosChannel, JSON.stringify({ type: 99 }))
        alarmResponseAPI({ id: dataId })
      }
    },

    closeCallDialog() { this.isCall = false },

    handleRiskWarning(dataId) {
      this.$mqtt.publish(this.sosChannel, JSON.stringify({ type: 99 }))
      alarmResponseAPI({ id: dataId })
    },

    // ==================== MQTT ====================
    connect() {
      this.$mqtt.on('connect', () => console.log('MQTT连接成功'))
      this.$mqtt.subscribe(this.sosChannel, () => console.log('已订阅SOS频道'))
      this.$mqtt.on('message', (topic, msgRes) => {
        const msg = JSON.parse(msgRes.toString())
        this.getAllData()
        this.dataTimer = setInterval(() => this.getAllData(), 60000)

        const type = msg.from
        const isAlert = [1, 2, 3, 4].includes(type)

        if (isAlert) {
          this.playAudio()
          clearInterval(this.startTimer)
          this.startTimer = setInterval(() => { this.startFlag = !this.startFlag }, 800)
          clearInterval(this.dataTimer)
        }

        switch (msg.type) {
          case 1: // SOS求救
            this.handleSosAlert(msg, type)
            break
          case 2: // 燃气报警
            this.handleGasAlert(msg)
            break
          case 4: // 离床警告
            this.handleBedAlert(msg)
            break
          case 5: // 派车
            this.playPromptAudio()
            this.carApplication.unshift(msg)
            break
          case 6: // 点餐
            this.playPromptAudio()
            this.meal.unshift(msg)
            break
          case 7: // 心率警告
          case 8: // 呼吸警告
            this.handleVitalAlert(msg, msg.type === 7 ? '心率预警' : '呼吸预警')
            break
          case 99: // 取消报警
            this.sosShow = false
            this.gasShow = false
            this.sosOtherShow = false
            if (this.$refs.audio) this.$refs.audio.pause()
            this.getAllData()
            break
        }
      })
    },

    handleSosAlert(msg, type) {
      const data = msg.data
      if (type === 1) {
        this.sosInfo = {
          sex: data.sex == 1 ? '男' : data.sex == 2 ? '女' : '未知',
          mobile: data.mobile,
          photo: data.photo,
          realname: data.realname,
          medication: data.medication,
          birthday: data.birthday,
          disease: data.disease,
          userId: data.id,
          alarmId: data.alarm ? data.alarm.id : '',
          address: [data.room.floor.building.area.name, data.room.floor.building.name, data.room.floor.name, data.room.name].filter(Boolean).join('')
        }
        this.sosShow = true
        setTimeout(() => { this.sosShow = false }, 60000)
      } else {
        this.sosOtherShow = true
        this.sosOtherInfo = { title: data.location, photo: data.location_photo }
        setTimeout(() => { this.sosOtherShow = false }, 60000)
      }
    },

    handleGasAlert(msg) {
      const data = msg.data
      this.gasInfo = {
        address: [data.room.floor.building.area.name, data.room.floor.building.name, data.room.floor.name, data.room.name].join(''),
        realname: data.realname,
        photo: data.photo
      }
      this.gasShow = true
      setTimeout(() => { this.gasShow = false }, 60000)
    },

    handleBedAlert(msg) {
      const data = msg.data
      this.sosInfo = {
        sex: data.sex == 1 ? '男' : data.sex == 2 ? '女' : '未知',
        mobile: data.mobile,
        photo: data.photo,
        realname: data.realname,
        birthday: data.birthday,
        title: '离床时间预警'
      }
      this.sosShow = true
      setTimeout(() => { this.sosShow = false }, 60000)
    },

    handleVitalAlert(msg, title) {
      const data = msg.data
      this.sosInfo = {
        sex: data.sex == 1 ? '男' : data.sex == 2 ? '女' : '未知',
        mobile: data.mobile,
        photo: data.photo,
        realname: data.realname,
        birthday: data.birthday,
        title
      }
      this.sosShow = true
      setTimeout(() => { this.sosShow = false }, 60000)
    },

    // ==================== 音频 ====================
    playAudio() {
      if (!this.TurnOnSound || this.isCall) return
      this.needVideo = true
      this.$nextTick(() => {
        if (this.$refs.audio) {
          this.$refs.audio.play()
          this.mutedFlag = false
        }
      })
    },

    closeAudio() {
      this.needVideo = false
      this.$mqtt.publish(this.sosChannel, JSON.stringify({ type: 99 }))
      if (this.$refs.audio) this.$refs.audio.pause()
      this.mutedFlag = true
      clearInterval(this.startTimer)
    },

    playPromptAudio() {
      if (!this.TurnOnSound) return
      this.needPromptVideo = true
      this.$nextTick(() => {
        if (this.$refs.audio2) {
          this.$refs.audio2.play()
          this.mutedPromptFlag = false
        }
      })
    },

    closePromptAudio() {
      this.needPromptVideo = false
      if (this.$refs.audio2) this.$refs.audio2.pause()
      this.mutedPromptFlag = true
    },

    closePopup() {
      this.sosShow = false
      this.sosOtherShow = false
      this.gasShow = false
      this.closeAudio()
    }
  }
}
</script>

<style scoped lang="less">
/* ==================== 全局 ==================== */
.main {
  width: 100%;
  height: 100vh;
  background: url('../../assets/large-screen/large-screen.-bg.jpg') center / cover no-repeat;
  user-select: none;
  overflow: hidden;
}

/* ==================== 顶部栏 ==================== */
.head {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  width: 100%;
  height: 7.4vh;
  background: url('../../assets/large-screen/large-head.png') center / 100% 100% no-repeat;

  .head-left {
    display: flex;
    position: absolute;
    top: 1.3vh;
    left: 2.7vw;
    gap: 2vw;
  }

  .head-date {
    font-size: 1.25vw;
    color: #45A2FF;
  }

  .head-week {
    font-size: 1.25vw;
    color: #45A2FF;
  }

  .head-time {
    font-size: 1.25vw;
    color: #fff;
  }

  .head-title {
    margin-top: 0.5vh;
    font-size: 1.75vw;
    font-weight: 700;
    color: #fff;
    letter-spacing: 4px;
  }

  .head-exit {
    position: absolute;
    top: 0.5vh;
    right: 2.7vw;
    color: #fff;
    font-size: 1.75vw;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }
  }
}

/* ==================== 主体 ==================== */
.body {
  display: flex;
  padding: 0 1.3vw;
  width: 100%;
  height: 88.8vh;
  box-sizing: border-box;
}

.body-left,
.body-right {
  width: 26.8vw;
  display: flex;
  flex-direction: column;
}

.body-mid {
  width: 42.2vw;
  margin: 0 0.8vw;
  display: flex;
  flex-direction: column;
}

/* ==================== 通用面板 ==================== */
.panel {
  box-shadow: inset 0 0 20px rgba(22, 88, 167, 0.5);
  background: rgba(8, 26, 48, 0.85);
  margin-bottom: 1.3vh;
  overflow: hidden;
}

.panel-flex {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.panel-flex-last {
  flex: 1.4;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* 面板头部 */
.panel-header {
  display: flex;
  align-items: center;
  height: 4.6vh;
  padding: 0.2vh 0;
  gap: 0.4vw;
}

.panel-header-bar {
  width: 3px;
  height: 3.5vh;
  background: #1B7EF2;
  border-radius: 2px;
  flex-shrink: 0;
}

.panel-header-title {
  font-size: 1.25vw;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.87);
  padding: 6px 12px;
  background: rgba(27, 126, 242, 0.14);
  border-radius: 2px;
  line-height: 1;
}

/* 特定面板高度 */
.body-left .panel:first-child { height: 28.7vh; }

/* ==================== ECharts ==================== */
.echart-carousel {
  width: 100%;
  height: 22vh;
  padding-top: 1vh;
}

.pie-chart {
  width: 100%;
  height: 20vh;
}

/* ==================== 通用表格样式 ==================== */
.simple-table, .data-table {
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.simple-table-head,
.data-table-head,
.vital-table-head,
.meal-table-head {
  display: flex;
  align-items: center;
  height: 3.1vh;
  font-size: 0.73vw;
  color: #01C2FF;
  background: #0F2B3F;
  border-radius: 3px;
  margin-bottom: 0.9vh;
  flex-shrink: 0;
}

.simple-table-body,
.data-table-body {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.data-table-body-sm {
  max-height: 13.3vh;
}

.simple-table-row,
.data-table-row {
  display: flex;
  align-items: center;
  min-height: 4vh;
  font-size: 0.63vw;
  color: #fff;
  background: #0F2B3F;
  border-radius: 3px;
  margin-bottom: 0.9vh;
}

/* 列宽 */
.col-3 { width: 4.1vw; text-align: center; }
.col-4 { width: 5.4vw; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; }
.col-4-half { width: 3.4vw; }
.col-5 { width: 7.5vw; display: flex; flex-direction: column; align-items: center; justify-content: center; }
.col-6 { width: 5.5vw; display: flex; justify-content: center; gap: 4px; }
.col-12 { width: 4.7vw; text-align: center; }
.col-13 { width: 10.9vw; text-align: center; }
.col-13-half { width: 4vw; text-align: center; }
.col-14 { width: 4.5vw; display: flex; justify-content: center; gap: 4px; }

.time-sep {
  transform: scale(0.5);
  opacity: 0.4;
}

.new-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #ff4d4f;
  border-radius: 50%;
  margin-right: 4px;
  animation: pulse-dot 1.5s ease-in-out infinite;
}

/* ==================== 按钮 ==================== */
.btn {
  display: inline-block;
  padding: 2px 8px;
  font-size: 0.75vw;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s;

  &:hover { opacity: 0.85; }
}

.btn-primary { background: #01C2FF; }
.btn-success { background: #00AA28; }
.btn-block { display: block; width: 80%; margin: 0 auto; text-align: center; line-height: 2.4vh; }

/* ==================== 空数据 ==================== */
.empty-row {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 6vh;
  color: rgba(255, 255, 255, 0.35);
  font-size: 0.7vw;
}

/* ==================== 风险预警 ==================== */
.panel-alert {
  height: 54vh;
  background-image: url('../../assets/large-screen/large-center-bg2.png');
  background-size: 100% 100%;
}

.alert-content {
  display: flex;
  height: 100%;
  padding: 3.5vh 0 1.4vh 0.9vw;
  box-sizing: border-box;
}

.alert-left {
  width: 25.7vw;
  display: flex;
  flex-direction: column;
  background: linear-gradient(to bottom, rgba(8, 14, 30, 1), rgba(8, 14, 30, 0.74), rgba(2, 8, 20, 0.28));
  padding-bottom: 1vh;
}

.alert-left-head {
  display: flex;
  align-items: center;
  height: 4.6vh;
  margin-top: 1.5vh;
  gap: 0.4vw;
}

.alert-sound-toggle {
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: 1vw;

  .sound-label {
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.6vw;
    margin-right: 6px;
  }
}

.alert-table-head {
  display: flex;
  align-items: center;
  height: 3.1vh;
  margin: 1.7vh 0 0.5vh 0.5vw;
  font-size: 0.73vw;
  color: #159AFF;
  background: #023164;
  width: 24.6vw;
  font-weight: 500;
}

.alert-table-body {
  flex: 1;
  overflow-y: auto;
  margin-left: 0.5vw;
  width: 24.6vw;
  min-height: 0;
}

.alert-table-row {
  display: flex;
  align-items: center;
  min-height: 2.8vh;
  font-size: 0.63vw;
  color: #fff;
  background: #0F2B3F;
  margin-bottom: 0.4vh;
}

/* ==================== 弹窗区 ==================== */
.alert-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-left: 0.5vw;
}

.popup-sos {
  background: url('../../assets/large-screen/sos.png') top / 100% auto no-repeat;
  padding: 1.3vh 0 0;
}

.popup-placeholder {
  height: 16vh;
  display: flex;
  justify-content: flex-end;
}

.popup-gas {
  margin-top: 10vh;
  height: 13.5vh;
  background: url('../../assets/large-screen/gas.png') center / 100% 100% no-repeat;
  display: flex;
  align-items: center;
}

.popup-card {
  width: 12.8vw;
  background: #fff;
  border-radius: 6px;
  margin: 0 auto;
  padding: 8px 10px;
  box-sizing: border-box;
  transition: box-shadow 0.3s;
}

.popup-gas-card {
  margin-left: 0.4vw;
  height: auto;
}

.popup-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.popup-icon {
  width: 0.85vw;
  height: auto;
}

.popup-icon-location {
  width: 0.8vw;
  height: auto;
}

.popup-close {
  cursor: pointer;
  opacity: 0.6;
  &:hover { opacity: 1; }
}

.popup-title {
  font-size: 0.63vw;
  font-weight: 500;
  color: #4C4C4C;
  margin-left: 4px;
}

.popup-location-text {
  font-size: 0.8vw;
  font-weight: 500;
  color: #4C4C4C;
  margin-left: 4px;
}

.popup-user {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.popup-avatar {
  width: 1.5vw;
  height: 2.7vh;
  border-radius: 50%;
  margin-right: 0.5vw;
}

.popup-name {
  font-size: 0.73vw;
  font-weight: 500;
  color: #4C4C4C;
}

.popup-info {
  font-size: 0.52vw;
  color: #4C4C4C;
  line-height: 2.2vh;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  justify-content: space-between;
  padding: 0 0.8vw;
}

.popup-action {
  margin: 10px 0 6px;
  display: flex;
  justify-content: center;
}

.popup-sos-other {
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-other-card {
  width: 12.4vw;
  background: #fff;
  border-radius: 6px;
  padding: 8px 10px;
  box-sizing: border-box;
}

.popup-map {
  width: 11vw;
  height: 9.4vh;
  border-radius: 3px;
  margin-top: 4px;
}

/* SOS/燃气弹窗背景 */
.popup-sos {
  background-image: url('../../assets/large-screen/sos.png');
}
.popup-sos-other {
  background-image: url('../../assets/large-screen/sosBg_2.png');
  background-size: 100% 100%;
  width: 13.2vw;
  height: 18.6vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.border-alert {
  box-shadow: inset 0 0 20px #ff4d4f;
}

.border-normal {
  box-shadow: inset 0 0 20px transparent;
}

/* ==================== 生命体征 ==================== */
.panel-vital {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.vital-table {
  width: 95%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.vital-table-head {
  height: 3.7vh;
}

.vital-table-body {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.vital-table-row {
  display: flex;
  align-items: center;
  min-height: 3.7vh;
  font-size: 0.63vw;
  color: #fff;
  background: #0F2B3F;
  border-radius: 3px;
  margin-bottom: 0.9vh;
}

.v-col {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3.7vh;
}

.v-col-1 { width: 3vw; }
.v-col-2 { width: 8vw; text-align: center; }
.v-col-3 { width: 7vw; text-align: center; }
.v-col-4 { width: 5vw; display: flex; align-items: center; justify-content: center; gap: 4px; }

/* 床垫状态 */
.vital-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  flex-shrink: 0;
}

.vital-dot-0 { background: #B6B6B6; }
.vital-dot-1 { background: #2BF159; }
.vital-dot-2 { background: #2BF159; }

.vital-status-text {
  font-size: 0.63vw;
  white-space: nowrap;
}

.vital-status-0 { color: #B6B6B6; }
.vital-status-1 { color: #2BF159; }
.vital-status-2 { color: #2BF159; }

/* ==================== 公告 ==================== */
.notice-scroll {
  height: 20.6vh;
  overflow-y: auto;
  padding: 0 1.7vw;
}

.notice-card {
  padding: 1vh 0;

  .notice-card-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.8vh;
  }

  .notice-card-title {
    font-size: 1vw;
    font-weight: 700;
    color: #fff;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    flex: 1;
    margin-right: 1vw;
  }

  .notice-card-time {
    font-size: 0.83vw;
    color: rgba(255, 255, 255, 0.6);
    flex-shrink: 0;
  }

  .notice-card-body {
    font-size: 0.68vw;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.8;
  }
}

/* ==================== 叫餐 ==================== */
.meal-table {
  width: 95%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.meal-table-body {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.meal-table-row {
  display: flex;
  align-items: center;
  height: 3.1vh;
  font-size: 0.63vw;
  color: #fff;
  background: #0F2B3F;
  border-radius: 3px;
  margin-bottom: 0.9vh;
}

.meal-col {
  width: 5.2vw;
  height: 3.1vh;
  line-height: 3.1vh;
  display: flex;
  align-items: center;
}

.meal-col-wide {
  width: 10vw;
  height: 3.1vh;
  line-height: 3.1vh;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* ==================== 工具类 ==================== */
.flex-1 { flex: 1; }
.text-center { text-align: center; }
.row { display: flex; align-items: center; }

/* ==================== 隐藏滚动条 ==================== */
::-webkit-scrollbar { width: 0 !important; height: 0 !important; }

/* ==================== 动画 ==================== */
@keyframes pulse-dot {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

.audio-hidden { display: none; }
</style>

<style>
/* 全局非 scoped 样式 - Carousel 指示器 */
#large-screen-index .body-left .panel:first-child .el-carousel__button {
  width: 6px;
  height: 6px;
  border: none;
  border-radius: 100px;
  background: #114688;
  transition: all 0.3s;
}

#large-screen-index .body-left .panel:first-child .el-carousel .is-active .el-carousel__button {
  width: 18px;
  height: 6px;
  border-radius: 100px;
  background: #0783FA;
}
</style>
